import { Injectable } from '@angular/core';
import { ClosedCaseVisibility } from '../../domain/enums/closed-case-visibility.enum';
import { InvestigationTypeEntity } from '../../domain/entities/investigation-type.entity';
import { InvestigationTypeDetailEntity } from '../../domain/entities/investigation-type-detail.entity';
import { InvestigationTypeCategoryEntity } from '../../domain/entities/investigation-type-category.entity';
import {
  InvestigationTypeDeletionImpactEntity,
  LinkedInvestigationEntity,
  LinkedInvestigationFormEntity,
  LinkedEmailTemplateEntity,
  LinkedProcessChecklistEntity,
} from '../../domain/entities/investigation-type-deletion-impact.entity';
import { InvestigationTypeResponseDto } from '../dtos/investigation-type-response.dto';
import { InvestigationTypeDetailResponseDto } from '../dtos/investigation-type-detail-response.dto';
import { InvestigationTypeCategoryResponseDto } from '../dtos/investigation-type-category-response.dto';
import { InvestigationTypeDeletionImpactResponseDto } from '../dtos/investigation-type-deletion-impact-response.dto';

@Injectable({ providedIn: 'root' })
export class InvestigationTypeMapper {
  toDomain(dto: InvestigationTypeResponseDto): InvestigationTypeEntity {
    return new InvestigationTypeEntity(
      dto.id,
      dto.name,
      dto.description,
      dto.categoryId,
      dto.categoryName,
      dto.isActive,
      dto.sortOrder,
      dto.checklistDisplayOnCases,
      dto.closedCaseVisibility ?? ClosedCaseVisibility.OpenToEveryone,
      dto.hasPublishedForm ?? false,
    );
  }

  toDomainArray(dtos: InvestigationTypeResponseDto[]): InvestigationTypeEntity[] {
    return dtos.map((dto) => this.toDomain(dto));
  }

  toDetailDomain(dto: InvestigationTypeDetailResponseDto): InvestigationTypeDetailEntity {
    return new InvestigationTypeDetailEntity(
      dto.id,
      dto.name,
      dto.description,
      dto.categoryId,
      dto.categoryName,
      dto.isActive,
      dto.sortOrder,
      dto.checklistDisplayOnCases,
      dto.closedCaseVisibility ?? ClosedCaseVisibility.OpenToEveryone,
      dto.createdOn,
      dto.updatedOn,
      dto.hasPublishedForm ?? false,
    );
  }

  toCategoryDomain(dto: InvestigationTypeCategoryResponseDto): InvestigationTypeCategoryEntity {
    return new InvestigationTypeCategoryEntity(
      dto.id,
      dto.name,
      dto.description,
      dto.sortOrder,
      dto.isActive,
    );
  }

  toCategoryDomainArray(dtos: InvestigationTypeCategoryResponseDto[]): InvestigationTypeCategoryEntity[] {
    return dtos.map((dto) => this.toCategoryDomain(dto));
  }

  public toDeletionImpactDomain(dto: InvestigationTypeDeletionImpactResponseDto): InvestigationTypeDeletionImpactEntity {
    const entity = new InvestigationTypeDeletionImpactEntity();
    entity.activeInvestigationsCount = dto.activeInvestigationsCount;
    entity.linkedInvestigations = dto.linkedInvestigations.map((i) => {
      const linkedInvestigation = new LinkedInvestigationEntity();
      linkedInvestigation.id = i.id;
      linkedInvestigation.name = i.name;
      return linkedInvestigation;
    });
    entity.linkedInvestigationForms = dto.linkedInvestigationForms.map((f) => {
      const linkedForm = new LinkedInvestigationFormEntity();
      linkedForm.id = f.id;
      linkedForm.name = f.name;
      return linkedForm;
    });
    entity.linkedEmailTemplates = dto.linkedEmailTemplates.map((t) => {
      const linkedTemplate = new LinkedEmailTemplateEntity();
      linkedTemplate.id = t.id;
      linkedTemplate.name = t.name;
      return linkedTemplate;
    });
    entity.linkedProcessChecklists = dto.linkedProcessChecklists.map((c) => {
      const linkedChecklist = new LinkedProcessChecklistEntity();
      linkedChecklist.id = c.id;
      linkedChecklist.name = c.name;
      return linkedChecklist;
    });
    entity.hasDependencies = dto.hasDependencies;
    return entity;
  }
}
